import { render, staticRenderFns } from "./ContentLoader.vue?vue&type=template&id=40d4965a&"
import script from "./ContentLoader.vue?vue&type=script&lang=ts&"
export * from "./ContentLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports